import * as React from "react";

import * as PropTypes from "prop-types";

import "./Bar.css";

import AppBar from "@material-ui/core/AppBar";
import InputBase from "@material-ui/core/InputBase";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";

import SearchIcon from "@material-ui/icons/Search";

import {
  createStyles,
  Theme,
  withStyles,
  WithStyles
} from "@material-ui/core/styles";
import { fade } from "@material-ui/core/styles/colorManipulator";
import { QueryFunction } from "src/typing";

const styles = (theme: Theme) =>
  createStyles({
    grow: {
      flexGrow: 1
    },
    inputInput: {
      paddingBottom: theme.spacing.unit,
      paddingLeft: theme.spacing.unit * 10,
      paddingRight: theme.spacing.unit,
      paddingTop: theme.spacing.unit,
      transition: theme.transitions.create("width"),
      width: "100%",
      [theme.breakpoints.up("md")]: {
        width: 200
      }
    },
    inputRoot: {
      color: "inherit",
      width: "100%"
    },
    menuButton: {
      marginLeft: -12,
      marginRight: 20
    },
    root: {
      width: "100%"
    },
    search: {
      "&:hover": {
        backgroundColor: fade(theme.palette.common.white, 0.25)
      },
      backgroundColor: fade(theme.palette.common.white, 0.15),
      borderRadius: theme.shape.borderRadius,
      marginLeft: 0,
      marginRight: theme.spacing.unit * 2,
      position: "relative",
      width: "100%",
      [theme.breakpoints.up("sm")]: {
        marginLeft: theme.spacing.unit * 3,
        width: "auto"
      }
    },
    searchIcon: {
      alignItems: "center",
      display: "flex",
      height: "100%",
      justifyContent: "center",
      pointerEvents: "none",
      position: "absolute",
      width: theme.spacing.unit * 9
    },
    sectionDesktop: {
      display: "none",
      [theme.breakpoints.up("md")]: {
        display: "flex"
      }
    },
    sectionMobile: {
      display: "flex",
      [theme.breakpoints.up("md")]: {
        display: "none"
      }
    },
    title: {
      display: "none",
      [theme.breakpoints.up("sm")]: {
        display: "block"
      }
    }
  });

export interface IProps extends WithStyles<typeof styles> {
  queryFn: QueryFunction;
}

export interface IState {
  query: string;
}

class TitleBar extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = { query: "" };

    this.onValueChange = this.onValueChange.bind(this);
    this.submit = this.submit.bind(this);
  }

  public render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <AppBar position="static" color="primary">
          <Toolbar>
            <Typography className={classes.title} variant="h6" color="inherit">
              Dashboard
            </Typography>
            <div className={classes.search}>
              <div className={classes.searchIcon}>
                <SearchIcon />
              </div>
              <InputBase
                placeholder="Search…"
                onKeyPress={this.submit}
                onChange={this.onValueChange}
                classes={{
                  input: classes.inputInput,
                  root: classes.inputRoot
                }}
              />
            </div>
          </Toolbar>
        </AppBar>
      </div>
    );
  }

  private onValueChange(e: React.ChangeEvent<HTMLInputElement>) {
    this.setState({
      query: e.target.value
    });
  }

  private submit(e: React.KeyboardEvent<HTMLInputElement>) {
    if (e.key !== "Enter") {
      return;
    }

    this.props.queryFn(this.state.query, 0);
  }
}

(TitleBar as React.ComponentClass<IProps>).propTypes = {
  classes: PropTypes.object.isRequired
} as any;
export default withStyles(styles)(TitleBar);



// WEBPACK FOOTER //
// ./src/components/Bar/Bar.tsx